var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "#F7ECE8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6454 30H20.4753V17.7519H24.5675V13.674H20.4753V10.9506C20.7177 9.69585 21.0884 8.79755 23.1986 8.22721H25.922V4.13501H21.8441C18.4221 4.57703 16.0551 6.68729 16.3973 10.9506V13.674H12.3194V17.7519H16.3973V30H1.42585C1.06935 29.9707 0.733595 29.8203 0.474255 29.574C0.214915 29.3276 0.0475733 29 0 28.6455V1.42585C0.0321228 1.05849 0.192652 0.714216 0.453412 0.453456C0.714172 0.192696 1.05849 0.0321228 1.42585 0H28.6454C29.001 0.0450343 29.3301 0.211581 29.5769 0.471427C29.8238 0.731273 29.9732 1.06845 30 1.42585V28.6455C29.958 28.9901 29.8017 29.3107 29.5562 29.5562C29.3107 29.8018 28.9901 29.958 28.6454 30Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.d22cf3c416a7c4ef24be61486c583079.svg";
export { ForwardRef as ReactComponent };